import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import TaskReport from '@components/TaskReport';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';

const moment = extendMoment(originalMoment);

const CompanyTask = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const _companyId = useSelector((state) => state.app.selectedCompany[0]);
    const _companies = useSelector((state) => state.app.companies);
    const data = useSelector((state) => state.manage.tasksReport);

    const [userId, setUserId] = useState(null);
    const [companyId, setCompanyId] = useState(_companyId);
    const [companies, setCompanies] = useState(_companies);
    const [dateStart, setDateStart] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const handleFilter = (type, data) => {
        if (data?.length < 1) return;

        if (type === 'company') {
            const cId = data[0].id;
            let cIds = [];

            if (cId > 0) {
                cIds.push(cId);
                setCompanyId(cId);
            } else {
                companies.forEach((item) => cIds.push(item.id));
                setCompanyId(-1);
            }
            const payload = { companyId: cIds, userId: null, dateStart, dateEnd };
            dispatch(ManageActions.companyindividualRequest(payload));
        } else {
            if (data[0].id > 0) {
                const user = data.map((item) => item.id);
                setUserId(user);
            } else {
                setUserId(null);
            }
        }
    };

    const handleTasks = (ds, de) => {
        let cIds = [];
        if (companyId > 0) cIds = [companyId];
        else cIds = companies.map((e) => e.id);

        const payload = { companyId: cIds, userId, dateStart: ds, dateEnd: de };
        dispatch(ManageActions.companyindividualRequest(payload));
        setDateStart(ds);
        setDateEnd(de);
    };

    const handleModal = (e) => {
        dispatch(AppActions.modalRequest(e));
    };

    return (
        <ErrorBoundary className="reports-task">
            <Filter onChange={handleFilter} />
            <TaskReport data={data} selected={userId} onClick={(e) => navigate(`/hcm/report-task/${e}`)} onTasks={handleTasks} onToggle={handleModal} />
        </ErrorBoundary>
    );
};

export default CompanyTask;
